import * as React from 'react';
import './TrialLookupsLayout.scss';
import { connect } from "react-redux";
import { RestrictedLayout } from "../../../components/layouts/index";
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { SettingsSubMenu } from '../../../helpers/subMenuHelper';
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";

interface ITrialLookupsLayoutProps {
    permissions?: Dtos.PersonnelTmdPermissions[];
    permission?: Dtos.Permission;
    loading?: boolean;
    children?: any;
}

interface ITrialLookupsLayoutActions {

}

type TrialLookupsLayoutProps = ITrialLookupsLayoutProps & ITrialLookupsLayoutActions;

class TrialLookupsLayout extends React.PureComponent<TrialLookupsLayoutProps, any> {

    constructor(props: TrialLookupsLayoutProps) {
        super(props);

    }

    render() {

        const {
            loading,
            permissions,
            permission
        } = this.props;

        let menu: any[] = []; 
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialCategoriesView)) {
            menu.push({
                icon: undefined,
                title: "Trial Categories",
                url: "/settings/trial/trialcategorys"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TumorGroupsView)) {
            menu.push({
                icon: undefined,
                title: "Tumour Groups",
                url: "/settings/trial/tumourgroups"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.AllocatedWPsView)) {
            menu.push({
                icon: undefined,
                title: "Allocated WPs",
                url: "/settings/trial/allocatedwps"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPhasesView)) {
            menu.push({
                icon: undefined,
                title: "Trial Phases",
                url: "/settings/trial/trialphases"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.InvolvementsView)) {
            menu.push({
                icon: undefined,
                title: "Involvement",
                url: "/settings/trial/involvements"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialAnalysisTypesView)) {
            menu.push({
                icon: undefined,
                title: "Analysis Types",
                url: "/settings/trial/trialAnalysisTypes"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPresentationTypesView)) {
            menu.push({
                icon: undefined,
                title: "Presentation Types",
                url: "/settings/trial/trialPresentationTypes"
            });
        }
        if (AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPublicationTypesView)) {
            menu.push({
                icon: undefined,
                title: "Publication Types",
                url: "/settings/trial/trialPublicationTypes"
            });
        }
        if (false && AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TemplateTrialItemsView)) {
            menu.push({
                icon: undefined,
                title: "Template Trial Items",
                url: "/settings/trial/templatetrialitems"
            });
        }

        return <RestrictedLayout
            subMenuItems={loading ? [] : SettingsSubMenu(permissions)}
            sub2MenuItems={loading ? [] : menu}
            loading={loading}
        >
            {permissions.length > 0 && permission && !AuthenticationHelper.hasPermission(permissions, permission) ?
                <div className="alert alert-warning d-flex">
                    <div className="mr-2">
                        <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                    </div>
                    <span>Permission Denied</span>
                </div>
                : this.props.children}
        </RestrictedLayout>;
    }

}


const mapStateToProps = (state: ITmdState, ownProps: TrialLookupsLayoutProps): ITrialLookupsLayoutProps => {
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
    return {
        permissions: permissions,
        permission: ownProps.permission,
        loading: ownProps.loading,
        children: ownProps.children
    };
};

const mapDispatchToProps = (dispatch): ITrialLookupsLayoutActions => {
    return {
        
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TrialLookupsLayout);
